/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useMutation, ServerError, useLazyQuery } from '@apollo/client'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { fetchStart, fetchStop } from '../../../../redux/actions/common'
import mutations from '../../../../setup/graphql/mutations'
import query from '../../../../setup/graphql/query'
import Alert from '../../../../_metronic/partials/alert'
import {
  setApplicationComplete,
  setCoApplicant,
  setOpenVerification,
  setSubStep,
} from '../redux/actions'
import { privacyPolicy } from '../../../../_metronic/helpers'
import { toStr } from '../../loanApplication/steps/Step3'
import PhoneInput from 'react-phone-number-input'
import { RightAeroIcon } from '../../../../svg/RightAeroIcon'
import { cleanFileNameDynamic } from '../../../../constants/commonFunctions'
import { Popover, Stack } from 'react-bootstrap'
import { UploadIcon } from '../../../../svg/UploadIcon'
import { Xicon } from '../../../../svg/Xicon'
import { OverlayTrigger } from 'react-bootstrap-v5'
import '../CoApplicant.scss'
import { LeftArowIcon } from '../../../../svg/LeftArowIcon'
// import {
//   uploadCbsReport,
//   processCbsReport,
//   initiateCbsTransaction,
// } from '../../../../components/BankStatementValidator/utils/cbsTransaction'

export const historyHead = [
  'yearofassessment',
  'trade',
  'category',
  'employment',
  'amount',
  'interest',
  'rent',
  'taxclearance',
]

const Step1Sub3: FC<any> = ({ getCoApplicant }) => {
  const dispatch = useDispatch()
  const history: any = useHistory()

  localStorage.removeItem('singpass')
  const agentCode = localStorage.getItem('agentCode')

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg, setAlertMsg] = useState<string>('')
  const [alertType, setAlertType] = useState<any>('primary')
  // const [information, setInformation] = useState<any>(null);
  const [fileGroup, setFileGroup] = useState<any>([])
  const [saveUserData, onSaveUserData] = useMutation(mutations.CREATE_EXTERNAL_DATA_STORE)
  const [updateCoApplicant, onUpdateCoApplicant] = useMutation(mutations.UPDATE_SHAREHOLDER_KYC)
  const [fetchBrigs, onSuccessFetchBrigs] = useLazyQuery(query.FETCH_BRIGS_DATA)
  const [createFileStorage, onSuccessCreateFileStorage] = useMutation(mutations.CREATE_FILE_STORAGE)
  const [deleteFileStorage] = useMutation(mutations.DELETE_FILE_STORAGE)

  const companyVerificationMethod = useSelector(
    (state: any) => state.coApplicant.companyVerificationMethod
  )

  // Ref for scrolling to consent checkbox when there's an error
  const consentBoxRef = useRef<HTMLDivElement>(null)
  // const coapplicant = useSelector((state: any) => state.coApplicant.co_applicant);
  const person = useSelector((state: any) => state.coApplicant.personData)

  const coApplicationId = localStorage.getItem('coApplicationId')
  const coApplicant = useSelector((state: any) => state.coApplicant.co_applicant)

  // CBS initiate transaction on component mount

  // useEffect(() => {
  //   const initiateCbs = async () => {
  //     try {
  //       await initiateCbsTransaction()
  //       console.log('CBS transaction initiated successfully')
  //     } catch (error) {
  //       console.error('Failed to initiate CBS transaction:', error)
  //     }
  //   }
  //   initiateCbs()
  // }, [])

  useEffect(() => {
    if (coApplicant == null) {
      getCoApplicant({
        variables: { shareholderId: localStorage.getItem('coApplicationId') },
      })
    }
  }, [])
  useEffect(() => {
    if (onSaveUserData.called && !onSaveUserData.loading) {
      if (onSaveUserData.data) {
        if (coApplicant.isGuarantor) {
          fetchBrigs({
            variables: {
              coApplicationId: coApplicationId,
            },
          })
        } else {
          updateCoApplicant({
            variables: {
              where: {
                id: coApplicationId,
              },
              data: {
                experianConsent: false,
                ...(companyVerificationMethod === 2
                  ? { dataViaSingpass: false, creationType: 'manual' }
                  : {}),
                kycStatus: 'completed',
              },
            },
          })
        }
      }

      if (onSaveUserData.error) {
        const { networkError } = onSaveUserData.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [onSaveUserData.data, onSaveUserData.error, onSaveUserData.loading])

  useEffect(() => {
    if (onSuccessFetchBrigs.called && !onSuccessFetchBrigs.loading) {
      if (onSuccessFetchBrigs.data) {
        updateCoApplicant({
          variables: {
            where: {
              id: coApplicationId,
            },
            data: {
              experianConsent: true,
              ...(companyVerificationMethod === 2
                ? { dataViaSingpass: false, creationType: 'manual' }
                : {}),
              kycStatus: 'completed',
            },
          },
        })
      }

      if (onSuccessFetchBrigs.error) {
        const { networkError } = onSuccessFetchBrigs.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [onSuccessFetchBrigs.data, onSuccessFetchBrigs.error, onSuccessFetchBrigs.loading])

  useEffect(() => {
    if (onUpdateCoApplicant.called && !onUpdateCoApplicant.loading) {
      if (onUpdateCoApplicant.data) {
        dispatch(fetchStop())
        dispatch(setCoApplicant(onUpdateCoApplicant.data.updateShareholderKycStatus))
        dispatch(setApplicationComplete(true))
        history.push(`/co-applicant-kyc/completed`)
      }

      if (onUpdateCoApplicant.error) {
        const { networkError } = onUpdateCoApplicant.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [onUpdateCoApplicant.data, onUpdateCoApplicant.error, onUpdateCoApplicant.loading])

  const initialValues: any = {
    uinfin: person?.uinfin?.value ?? '',
    name: person?.name?.value ?? '',
    sex: person?.sex?.desc ?? '',
    // race: person.race.desc,
    nationality: person?.nationality?.desc ?? '',
    dob: person?.dob?.value ?? '',
    email: person?.email?.value ?? '',
    mobileno: person
      ? `${person?.mobileno?.prefix?.value}${person?.mobileno?.areacode?.value}${person?.mobileno?.nbr?.value}`
      : '',
    // regadd: person ? `${person.regadd.block?.value} ${person.regadd.building?.value} ${person.regadd.floor?.value} ${person.regadd.unit?.value} ${person.regadd.street?.value} ${person.regadd.postal?.value}` : '',
    regadd: person ? toStr(person.regadd, 'ADDRESSLOCAL') : '',
    // housingtype: `${person.housingtype.desc} ${person.hdbtype.desc}`,
    // marital: person.marital.desc,
    // edulevel: person.edulevel.desc,
    residentialstatus: person?.residentialstatus?.desc ?? '',
    ownerprivate: person?.ownerprivate?.value ?? '',
    noahistory: person?.noahistory?.noas || [],
    confirmCheckbox: false,
    promotionalMarketingCheckbox: false,
  }

  const checkForLeadingTrailingSpaces = (value: string | undefined) => {
    if (!value) return true

    return value === value.trim()
  }

  const getValidationSchema = () => {
    // When companyVerificationMethod === 1, bypass validation for most fields
    if (companyVerificationMethod === 1) {
      return Yup.object().shape({
        name: Yup.string()
          .required('Name is required')
          .matches(/^[a-zA-Z\s,*]+$/, 'Name can only contain letters, spaces, and commas'),
        sex: Yup.string(),
        nationality: Yup.string(),
        regadd: Yup.string(),
        residentialstatus: Yup.string(),
        dob: Yup.string(),
        uinfin: Yup.string(),
        mobileno: Yup.string()
          .required('Mobile Number is required')
          .matches(/^\+?\d{8,15}$/, 'Please enter a valid mobile number with country code'),
        email: Yup.string()
          .required('Email is required')
          .email('Please enter a valid email address'),
        ownerprivate: Yup.string(),
        confirmCheckbox: Yup.bool().required('Please consent to above mandatory terms'),
      })
    }

    // Default validation schema for other verification methods
    return Yup.object().shape({
      name: Yup.string()
        .required('Name is required')
        .matches(/^[a-zA-Z\s,*]+$/, 'Name can only contain letters, spaces')
        .test(
          'no-asterisk-only',
          'Name cannot consist of only asterisks or spaces with asterisks',
          (value) => {
            if (!value) return false
            const trimmed = value.trim()

            return !/^[*\s]+$/.test(trimmed)
          }
        )
        .test('no-only-spaces', 'Name cannot be just spaces', (value) =>
          value ? value.trim().length > 0 : false
        )
        .test(
          'no-leading-trailing-spaces',
          'Name cannot have leading or trailing spaces',
          (value) => {
            if (!value) return true

            return value === value.trim()
          }
        ),

      sex: Yup.string()
        .required('Gender is required')
        .matches(/^[a-zA-Z\s]+$/, 'Gender should not contain numbers or special characters')
        .test('no-only-spaces', 'Gender cannot be just spaces', (value) =>
          value ? value.trim().length > 0 : false
        )
        .test(
          'no-leading-trailing-spaces',
          'Gender cannot have leading or trailing spaces',
          (value) => {
            if (!value) return true

            return value === value.trim()
          }
        ),

      nationality: Yup.string()
        .required('Nationality is required')
        .matches(/^[a-zA-Z\s]+$/, 'Nationality should not contain numbers or special characters')
        .test('no-only-spaces', 'Nationality cannot be just spaces', (value) =>
          value ? value.trim().length > 0 : false
        )
        .test(
          'no-leading-trailing-spaces',
          'Nationality cannot have leading or trailing spaces',
          (value) => {
            if (!value) return true

            return value === value.trim()
          }
        ),

      regadd: Yup.string()
        .required('Registered Address is required')
        .min(5, 'Address must be at least 5 characters')
        .max(200, 'Address must be at most 200 characters')
        .test(
          'not-just-spaces',
          'Only spaces are not allowed',
          (value) => !!value && value.trim().length > 0
        )
        .test(
          'contains-alphabets',
          'Address cannot have only numbers or special characters',
          (value) => (value ? /[a-zA-Z]/.test(value) : false)
        )
        .test(
          'no-leading-trailing-spaces',
          'Registered Address cannot have leading or trailing spaces',
          checkForLeadingTrailingSpaces
        ),

      residentialstatus: Yup.string()
        .required('Residential Status is required')
        .matches(
          /^[a-zA-Z\s]+$/,
          'Residential Status should not contain numbers or special characters'
        )
        .test('no-only-spaces', 'Residential Status cannot be just spaces', (value) =>
          value ? value.trim().length > 0 : false
        )
        .test(
          'no-leading-trailing-spaces',
          'Residential Status cannot have leading or trailing spaces',
          (value) => {
            if (!value) return true

            return value === value.trim()
          }
        ),

      dob: Yup.string()
        .required('Date of Birth is required')
        .test('format-or-year', 'Date format must be YYYY-MM-DD ', (value: any) => {
          if (!value) return false
          // Allow either YYYY-MM-DD or just YYYY
          return /^\d{4}(-\d{2}-\d{2})?$/.test(value)
        })
        .test('is-valid-date', 'Please enter a valid date', (value: any) => {
          if (!value) return true

          // If only year is provided (e.g., "1967"), append -01-01
          let dateStr = value
          if (/^\d{4}$/.test(value)) {
            dateStr = `${value}-01-01`
          }

          // Parse the date and check if it's valid
          const date = new Date(dateStr)
          if (isNaN(date.getTime())) return false

          // Verify that the parts match what was actually set
          // This catches cases like 2021-02-31 which would be converted to 2021-03-03 silently

          const [year, month, day] = dateStr.split('-').map(Number)
          const parsedDate = new Date(date)

          return (
            parsedDate.getFullYear() === year &&
            parsedDate.getMonth() + 1 === month &&
            parsedDate.getDate() === day
          )
        })
        .test('not-future', 'Date of Birth cannot be in the future', (value: any) => {
          if (!value) return true

          // If only year is provided, append -01-01
          let dateStr = value
          if (/^\d{4}$/.test(value)) {
            dateStr = `${value}-01-01`
          }

          const date = new Date(dateStr)

          return !isNaN(date.getTime()) && date <= new Date()
        }),

      uinfin: Yup.string()
        .required('NRIC/FIN is required')
        .matches(/^[a-zA-Z0-9]+$/, 'NRIC/FIN should only contain letters and numbers')
        .test('alphanumeric', 'NRIC/FIN must contain both letters and numbers', (value) => {
          if (!value) return false

          return /[a-zA-Z]/.test(value) && /\d/.test(value)
        })
        .test('no-only-spaces', 'NRIC/FIN cannot be just spaces', (value) =>
          value ? value.trim().length > 0 : false
        )
        .test(
          'no-leading-trailing-spaces',
          'NRIC/FIN cannot have leading or trailing spaces',
          (value) => {
            if (!value) return true

            return value === value.trim()
          }
        ),

      mobileno: Yup.string()
        .required('Mobile Number is required')
        .matches(/^\+?\d{8,15}$/, 'Please enter a valid mobile number with country code')
        .test('min-length', 'Mobile number must be at least 8 digits', (value) =>
          value ? value.replace(/\D/g, '').length >= 8 : false
        )
        .test('no-only-spaces', 'Mobile Number cannot be just spaces', (value) =>
          value ? value.trim().length > 0 : false
        )
        .test(
          'no-leading-trailing-spaces',
          'Mobile number cannot have leading or trailing spaces',
          (value) => {
            if (!value) return true

            return value === value.trim()
          }
        )
        .trim(),
      email: Yup.string()
        .required('Email is required')
        .test(
          'no-leading-trailing-spaces',
          'Email cannot have leading or trailing spaces',
          (value) => {
            if (!value) return true

            return value === value.trim()
          }
        )
        .email('Please enter a valid email address')
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          'Please enter a valid email address'
        )
        .test('no-only-spaces', 'Email cannot be just spaces', (value) =>
          value ? value.trim().length > 0 : false
        ),
      ownerprivate: Yup.string()
        .required('Owner Private is required')
        .test('no-only-spaces', 'Owner Private cannot be just spaces', (value) =>
          value ? value.trim().length > 0 : false
        ),
      confirmCheckbox: Yup.bool().required('Please consent to above mandatory terms'),
    })
  }

  const validationSchema = getValidationSchema()

  const removeSingleFile = async (id: string) => {
    const _fileGroup = fileGroup.filter((o: any) => o.id !== id)
    setFileGroup(_fileGroup)
    await deleteFileStorage({
      variables: {
        where: { id: id },
      },
    })
  }

  const isValidFile = (event: any, fileTypes: string[], docType: string = '') => {
    const excelTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-excel', // .xls
      'application/octet-stream', // Some Excel files might have this type
      'application/zip', // .xlsx is actually a zip file
    ]

    const isExcelFile = (file: File) => {
      const fileName = file.name.toLowerCase()
      return (
        excelTypes.includes(file.type) ||
        fileName.endsWith('.xlsx') ||
        fileName.endsWith('.xls') ||
        file.type === ''
      ) // Sometimes Excel files might not have a type
    }

    const isPdfFile = (file: File) => {
      return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
    }

    const isValidType = (file: File) => {
      if (fileTypes.includes('application/pdf') && isPdfFile(file)) return true
      if (
        (fileTypes.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
          fileTypes.includes('application/vnd.ms-excel')) &&
        isExcelFile(file)
      )
        return true
      return fileTypes.includes(file.type)
    }

    const checkType = [...event.target.files].some((file: File) => !isValidType(file))

    if (checkType) {
      const docTypeDisplay = getDocTypeDisplay(docType)

      setShowAlert(true)
      setAlertMsg(`Please upload a valid ${docTypeDisplay}`)
      setAlertType('primary')
      // Clear the file input
      event.target.value = ''
      event.target.files = null
      return false
    }
    return true
  }

  const getDocTypeDisplay = (docType: string): string => {
    switch (docType) {
      case 'identity-proof':
        return 'Identity Proof'
      case 'credit-bureau-singapore-document':
        return 'Credit Bureau Singapore Document'
      case 'mlcb-report':
        return 'MLCB Report'
      case 'noa-document':
        return 'NOA Document'
      default:
        return 'File'
    }
  }

  const handleFileUpload = async (
    event: any,
    type: string,
    fileType: string[] = ['application/pdf']
  ) => {
    if (event.target.validity.valid) {
      let files = []
      let uploadDocs = []

      const isValid = isValidFile(event, fileType, type)

      if (!isValid) return

      for (let file of event.target.files) {
        const isExists = fileGroup.some(
          (f: any) =>
            cleanFileNameDynamic(f.file.filename) === cleanFileNameDynamic(file.name) &&
            f.type === type
        )

        if (!isExists) {
          file.filename = file.name
          files.push({ type: type, file })
          uploadDocs.push({
            shareholderKycStatus: {
              connect: {
                id: coApplicationId,
              },
            },
            fileType: type,
            documentFile: {
              upload: file,
            },
            updatedByUserName: coApplicant?.personName ?? formik?.values?.name,
          })

          // Call CBS upload API for CBS documents
          // if (type === 'credit-bureau-singapore-document') {
          //   console.log('CBS document uploaded to Perfios successfully:', file.name)
          //   try {
          //     const loanApplicationId = localStorage.getItem('loanApplicationId')
          //     const shareholderId = localStorage.getItem('coApplicationId')

          //     // Use financial year logic: if current year is 2025, financial year is 2024
          //     const currentCalendarYear = new Date().getFullYear()
          //     const financialYear = (currentCalendarYear - 1).toString() // 2024 for FY 2024-25
          //     await uploadCbsReport(file, loanApplicationId!, financialYear, shareholderId!)
          //     console.log('CBS file uploaded to Perfios successfully:', file.name)
          //   } catch (error) {
          //     console.error('Failed to upload CBS file to Perfios:', error)
          //     // Continue with regular file storage even if CBS upload fails
          //   }
          // }
        } else {
          event.target.value = ''
          setShowAlert(true)
          setAlertMsg('File already exists')
          setAlertType('primary')
          return
        }
      }

      if (files.length) {
        event.target.value = ''
        createFileStorage({
          variables: {
            data: uploadDocs,
          },
        })
        event.target.value = ''
        dispatch(fetchStart())
      }
    }
  }

  useEffect(() => {
    if (onSuccessCreateFileStorage.called && !onSuccessCreateFileStorage.loading) {
      dispatch(fetchStop())
      if (onSuccessCreateFileStorage.data) {
        if (onSuccessCreateFileStorage.data) {
          const { createFileStorages } = onSuccessCreateFileStorage.data
          let file = [...fileGroup]
          for (const document of createFileStorages) {
            const _file = {
              id: document.id,
              type: document.fileType,
              file: document.documentFile,
            }
            file.push(_file)
          }

          setFileGroup(file)

          onSuccessCreateFileStorage.reset()
        }
      } else {
      }

      if (onSuccessCreateFileStorage.error) {
        const { networkError } = onSuccessCreateFileStorage.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
      }
    }
  }, [
    onSuccessCreateFileStorage.loading,
    onSuccessCreateFileStorage.data,
    onSuccessCreateFileStorage.error,
    onSuccessCreateFileStorage.called,
  ])

  function fileGroupValidation() {
    if (companyVerificationMethod === 2 && agentCode !== null) {
      return (
        fileGroup.some((f: any) => f.type === 'identity-proof') &&
        fileGroup.some((f: any) => f.type === 'utility-bill')
      )
    }
    return true
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    onSubmit: async (values: any, { setStatus, setSubmitting }: any) => {
      if (coApplicationId && fileGroupValidation()) {
        // Call CBS Process API if CBS documents were uploaded
        // try {
        //   console.log('🚀 Calling CBS Process API on Save and Continue...')
        //   await processCbsReport()
        //   console.log('✅ CBS Process API completed successfully')
        // } catch (error) {
        //   console.error('CBS Process API failed:', error)
        // }
        const trimmedValues = Object.fromEntries(
          Object.entries(values).map(([key, val]) => {
            if (typeof val === 'string') {
              const trimmed = val.trim()
              // If dob is only a year (YYYY), append -01-01
              if (key === 'dob' && /^\d{4}$/.test(trimmed)) {
                return [key, `${trimmed}-01-01`]
              }
              return [key, trimmed]
            }
            return [key, val]
          })
        )

        dispatch(fetchStart())
        // Call CBS Process API if CBS documents were uploaded
        // const hasCbsDocuments = fileGroup.some(
        //   (f: any) => f.type === 'credit-bureau-singapore-document'
        // )
        // if (hasCbsDocuments) {
        //   try {
        //     console.log('🚀 Calling CBS Process API on Save and Continue...')
        //     await processCbsReport()
        //     console.log('✅ CBS Process API completed successfully')
        //   } catch (error) {
        //     console.error('❌ CBS Process API failed:', error)
        //     // Continue with form submission even if CBS process fails
        //   }
        // }
        saveUserData({
          variables: {
            data: {
              shareholderKycStatus: {
                connect: {
                  id: coApplicationId,
                },
              },
              //TODO: add data fetched from singpass or manual entry here
              type: 'singpass',
              data: trimmedValues,
              // dataCreatedAt: new Date().toISOString()
            },
          },
        })
        setSubmitting(false)
      }
    },
  })
  // Add effect to scroll to consent box when validation fails
  useEffect(() => {
    // Check if there's a checkbox error and the form has been submitted
    if (
      formik?.submitCount > 0 &&
      formik?.errors?.confirmCheckbox &&
      !formik?.values?.confirmCheckbox &&
      consentBoxRef?.current
    ) {
      // Scroll the consent box into view with smooth behavior
      consentBoxRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [formik?.submitCount, formik?.errors?.confirmCheckbox, formik?.values?.confirmCheckbox])

  const backClick = () => {
    dispatch(setSubStep(2))
    dispatch(setOpenVerification(true))
    history.push(`/co-applicant-kyc/${coApplicant?.id}`)
  }

  return (
    <div className='d-flex flex-column flex-column-fluid w-100'>
      <div className='notice d-flex banner text-start p-6 mb-5'>
        <div className='d-flex flex-stack flex-grow-1'>
          <div>
            <h2>User Profile</h2>
            <div className='fs-3'>
              {companyVerificationMethod === 2 ? (
                <>Please provide following requested information</>
              ) : (
                <>
                  Please verify following details and provide additional information mentioned below
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className='cardNew'>
          <div className='section-heading'></div>
          <h2>Personal Information</h2>
          <hr className='text-gray-400' />
          <div className='row'>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                UINFIN
              </label>
              <div className='col-sm-12'>
                <input
                  name='uinfin'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.uinfin}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.uinfin && formik.errors.uinfin && (
                  <div className='text-danger mt-2'>{formik.errors.uinfin}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Name
              </label>
              <div className='col-sm-12'>
                <input
                  name='name'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.name && formik.errors.name && (
                  <div className='text-danger mt-2'>{formik.errors.name}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Sex
              </label>
              <div className='col-sm-12'>
                <input
                  name='sex'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.sex}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.sex && formik.errors.sex && (
                  <div className='text-danger mt-2'>{formik.errors.sex}</div>
                )}
              </div>
            </div>

            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Date of birth
              </label>
              <div className='col-sm-12'>
                <input
                  name='dob'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.dob}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {(formik.touched.dob || formik.touched.dob === null) && formik.errors.dob && (
                  <div className='text-danger mt-2'>{formik.errors.dob}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Mobile number
              </label>
              <div className='col-sm-12'>
                <PhoneInput
                  id='mobileno'
                  international
                  defaultCountry='SG'
                  value={formik.values.mobileno}
                  onChange={(value) => formik.setFieldValue('mobileno', value)}
                  onBlur={() => formik.setFieldTouched('mobileno', true)}
                  className='int-phone-input rounded-top rounded-bottom'
                />
                {formik.touched.mobileno && formik.errors.mobileno && (
                  <div className='text-danger mt-2'>{formik.errors.mobileno}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Email
              </label>
              <div className='col-sm-12'>
                <input
                  name='email'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={companyVerificationMethod === 1}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className='text-danger mt-2'>{formik.errors.email}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Nationality
              </label>
              <div className='col-sm-12'>
                <input
                  name='nationality'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.nationality}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.nationality && formik.errors.nationality && (
                  <div className='text-danger mt-2'>{formik.errors.nationality}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Residential Status
              </label>
              <div className='col-sm-12'>
                <input
                  name='residentialstatus'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.residentialstatus}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.residentialstatus && formik.errors.residentialstatus && (
                  <div className='text-danger mt-2'>{formik.errors.residentialstatus}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Registered Address
              </label>
              <div className='col-sm-12'>
                <input
                  name='regadd'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.regadd}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.regadd && formik.errors.regadd && (
                  <div className='text-danger mt-2'>{formik.errors.regadd}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Owner Private
              </label>
              <div className='col-sm-12'>
                <input
                  name='ownerprivate'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.ownerprivate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.ownerprivate && formik.errors.ownerprivate && (
                  <div className='text-danger mt-2'>{formik.errors.ownerprivate}</div>
                )}
              </div>
            </div>
            {/* files upload */}
            {companyVerificationMethod === 2 && agentCode !== null && (
              <div className='row'>
                <div className='col-md-6 mb-5'>
                  <div className='mb-2'>
                    <label
                      htmlFor=''
                      style={{ fontSize: '16px', fontWeight: 500 }}
                      className='input-field-label required mb-0'
                    >
                      Identity Proof
                    </label>
                  </div>
                  <span
                    className='fw-bold mb-7'
                    style={{
                      fontSize: '14px',
                      display: 'inline-block',
                      lineHeight: '1.1',
                      color: '#19147B',
                    }}
                  >
                    Upload Photo Identity Proof (NRIC, Passport, etc.)
                  </span>
                  <div
                    className='uploadBoxCoApp'
                    style={{
                      border: '1px dashed #BBBFC4',
                      padding: '63px 40px',
                      background: 'rgba(26,3,85,0.02)',
                      minHeight: '150px',
                      fontSize: '14px',
                      marginBottom: '15px',
                      borderRadius: '10px',
                      alignItems: 'center',
                    }}
                    onDrop={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                      const files = e.dataTransfer.files
                      if (files.length) {
                        const event = { target: { files, validity: { valid: true } } }
                        handleFileUpload(event, 'identity-proof', [
                          'image/jpeg',
                          'image/png',
                          'image/jpg',
                          'application/pdf',
                        ])
                      }
                    }}
                    onDragOver={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                    onDragLeave={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                  >
                    <Stack
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      gap={2} // Increased gap for better spacing
                    >
                      <div className='upload mb-4'>
                        <input
                          id='upload-identity-proof'
                          type='file'
                          multiple
                          accept='image/jpeg, image/png, image/jpg, application/pdf'
                          onChange={(e: any) =>
                            handleFileUpload(e, 'identity-proof', [
                              'image/jpeg',
                              'image/png',
                              'image/jpg',
                              'application/pdf',
                            ])
                          }
                          onDrop={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                            const files = e.dataTransfer.files
                            if (files.length) {
                              const event = { target: { files, validity: { valid: true } } }
                              handleFileUpload(event, 'identity-proof', [
                                'image/jpeg',
                                'image/png',
                                'image/jpg',
                                'application/pdf',
                              ])
                            }
                          }}
                          onDragOver={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                          onDragLeave={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                        ></input>
                        <label
                          htmlFor='upload-identity-proof'
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            className='file-uploader'
                            style={{
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                            }}
                          >
                            <UploadIcon color='var(--primary-color)' />

                            <span className='dragDropTitle'>
                              Drag & Drop Identity Proof Documents
                            </span>
                          </div>
                          <div className='file-uploader-sub'>Supported formats: JPEG, PNG, PDF</div>
                        </label>
                      </div>
                    </Stack>
                  </div>
                  <div className='uploadedCapsulesWrap'>
                    <Stack
                      className='uploadedCapsules gridCapsules'
                      style={{
                        display: 'grid', // Change to grid layout
                        gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
                        gap: '12px', // Adjusted gap for better spacing
                        fontSize: '12px',
                        minWidth: '100%',
                      }}
                    >
                      {fileGroup && fileGroup.length > 0 && (
                        <>
                          {fileGroup
                            .filter(({ type }: any) => type === 'identity-proof')
                            .map(({ file, type, id }: any, i: number) => {
                              const filename = file.filename.split('.')
                              const name = filename[0].substring(0, 10)
                              const extension = filename[1]

                              return (
                                <div
                                  key={i}
                                  style={{
                                    fontSize: 14,
                                    color: '#616B75',
                                    background: '#F9FAFA',

                                    border: '1px solid #E0E0E0',
                                    padding: '8px 16px',
                                    display: 'flex', // Use flex to position items
                                    justifyContent: 'space-between', // Space between text and icon
                                    alignItems: 'center', // Center items vertically
                                    width: '100%', // Set to 100% to fill the grid cell
                                  }}
                                  title={file.filename}
                                >
                                  <span>{`${name}...${extension}`}</span>
                                  <Xicon
                                    onClick={() => removeSingleFile(id)}
                                    className='cursor-pointer'
                                  />
                                </div>
                              )
                            })}
                        </>
                      )}
                    </Stack>
                  </div>
                </div>
                <div className='col-md-6 mb-5'>
                  <div className='mb-2 d-flex align-items-center'>
                    <label
                      htmlFor=''
                      style={{ fontSize: '16px', fontWeight: 500 }}
                      className='input-field-label required mb-0'
                    >
                      Utility Bills
                    </label>
                    &nbsp;
                    <OverlayTrigger
                      trigger='hover'
                      placement='right'
                      overlay={
                        <Popover>
                          <Popover.Body
                            style={{
                              backgroundColor: '#202020',
                              color: 'white',
                              borderRadius: '10px',
                              padding: '15px',
                            }}
                          >
                            Should clearly show the address and name.
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <svg
                        width='14'
                        height='14'
                        viewBox='0 0 14 14'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M7 5H7.00667M6.33333 7H7V9.66667H7.66667M1 7C1 7.78793 1.15519 8.56815 1.45672 9.2961C1.75825 10.0241 2.20021 10.6855 2.75736 11.2426C3.31451 11.7998 3.97595 12.2417 4.7039 12.5433C5.43185 12.8448 6.21207 13 7 13C7.78793 13 8.56815 12.8448 9.2961 12.5433C10.0241 12.2417 10.6855 11.7998 11.2426 11.2426C11.7998 10.6855 12.2417 10.0241 12.5433 9.2961C12.8448 8.56815 13 7.78793 13 7C13 5.4087 12.3679 3.88258 11.2426 2.75736C10.1174 1.63214 8.5913 1 7 1C5.4087 1 3.88258 1.63214 2.75736 2.75736C1.63214 3.88258 1 5.4087 1 7Z'
                          stroke='#787878'
                          stroke-width='1.5'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                        />
                      </svg>
                    </OverlayTrigger>
                  </div>
                  <span
                    className='fw-bold mb-7'
                    style={{
                      fontSize: '14px',
                      display: 'inline-block',
                      lineHeight: '1.1',
                      color: '#19147B',
                    }}
                  >
                    The bill cannot be older than 3 months from the current date
                  </span>
                  <div
                    className='uploadBoxCoApp'
                    style={{
                      border: '1px dashed #BBBFC4',
                      padding: '63px 40px',
                      background: 'rgba(26,3,85,0.02)',
                      minHeight: '150px',
                      fontSize: '14px',
                      marginBottom: '15px',
                      borderRadius: '10px',
                      alignItems: 'center',
                    }}
                    onDrop={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                      const files = e.dataTransfer.files
                      if (files.length) {
                        const event = { target: { files, validity: { valid: true } } }
                        handleFileUpload(event, 'utility-bill', [
                          'application/pdf',
                          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                          'application/msword',
                        ])
                      }
                    }}
                    onDragOver={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                    onDragLeave={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                  >
                    <Stack
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      gap={2} // Increased gap for better spacing
                    >
                      <div className='upload mb-4'>
                        <input
                          id='upload-utility-bills'
                          type='file'
                          multiple
                          accept='application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword'
                          onChange={(e: any) =>
                            handleFileUpload(e, 'utility-bill', [
                              'application/pdf',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                              'application/msword',
                            ])
                          }
                          onDrop={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                            const files = e.dataTransfer.files
                            if (files.length) {
                              const event = { target: { files, validity: { valid: true } } }
                              handleFileUpload(event, 'utility-bill', [
                                'application/pdf',
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                'application/msword',
                              ])
                            }
                          }}
                          onDragOver={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                          onDragLeave={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                        ></input>
                        <label
                          htmlFor='upload-utility-bills'
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            className='file-uploader'
                            style={{
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                            }}
                          >
                            <UploadIcon color='var(--primary-color)' />

                            <span className='dragDropTitle'>Drag & Drop Utility Bill</span>
                          </div>
                          <div className='file-uploader-sub'>Supported formats: PDF, DOCX</div>
                        </label>
                      </div>
                    </Stack>
                  </div>
                  <div className='uploadedCapsulesWrap'>
                    <Stack
                      className='uploadedCapsules gridCapsules'
                      style={{
                        display: 'grid', // Change to grid layout
                        gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
                        gap: '12px', // Adjusted gap for better spacing
                        fontSize: '12px',
                        minWidth: '100%',
                      }}
                    >
                      {fileGroup && fileGroup.length > 0 && (
                        <>
                          {fileGroup
                            .filter(({ type }: any) => type === 'utility-bill')
                            .map(({ file, type, id }: any, i: number) => {
                              const filename = file.filename.split('.')
                              const name = filename[0].substring(0, 10)
                              const extension = filename[1]

                              return (
                                <div
                                  key={i}
                                  style={{
                                    fontSize: 14,
                                    color: '#616B75',
                                    background: '#F9FAFA',

                                    border: '1px solid #E0E0E0',
                                    padding: '8px 16px',
                                    display: 'flex', // Use flex to position items
                                    justifyContent: 'space-between', // Space between text and icon
                                    alignItems: 'center', // Center items vertically
                                    width: '100%', // Set to 100% to fill the grid cell
                                  }}
                                  title={file.filename}
                                >
                                  <span>{`${name}...${extension}`}</span>
                                  <Xicon
                                    onClick={() => removeSingleFile(id)}
                                    className='cursor-pointer'
                                  />
                                </div>
                              )
                            })}
                        </>
                      )}
                    </Stack>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {companyVerificationMethod === 1 && agentCode !== null && (
          <div className='cardNew'>
            <div className='section-heading'>
              <h2>Notice of Assessment History</h2>
              <hr className='text-gray-400' />
            </div>

            <div className='table-wrapper px-2'>
              <table className='table table-bordered text-align-center w-100 px-2'>
                <thead className='table-header p-2'>
                  <tr className='text-dark'>
                    {formik.values.noahistory?.length > 0 &&
                      [...historyHead, ...Object.keys(formik.values.noahistory[0])]
                        .reduce(
                          (acc: any, curr: any) => (acc.includes(curr) ? acc : [...acc, curr]),
                          []
                        )
                        .map((key: any, i: number) => {
                          let tableHead = ''
                          if (key === 'taxclearance') tableHead = 'tax-clearance'
                          else if (key === 'yearofassessment') tableHead = 'year-of-assessment'
                          else tableHead = key

                          const value = tableHead
                            .replace(/-/g, ' ')
                            .replace(/(?: |\b)(\w)/g, (key: any, p1: any) => key.toUpperCase())
                          return (
                            <th className='min-w-150px' key={i}>
                              {value}
                            </th>
                          )
                        })}
                  </tr>
                </thead>
                <tbody>
                  {formik.values.noahistory.length > 0 &&
                    Object.values(formik.values.noahistory).map((list: any, i) => {
                      const headList: any = [
                        ...historyHead,
                        ...Object.keys(formik.values.noahistory[0]),
                      ].reduce(
                        (acc: any, curr: any) => (acc.includes(curr) ? acc : [...acc, curr]),
                        []
                      )
                      return (
                        <tr key={i}>
                          {headList.map((head: any, i: number) => {
                            let value = `${list[head].value}`

                            if (head === 'amount' || head === 'interest' || head === 'employment')
                              value = value
                                .toString()
                                .replace(/(\d)(?=(\d{3})+(\.(\d){0,2})*$)/g, '$1,')
                            if (head === 'amount' || head === 'interest') value = 'SG$ ' + value
                            else value = value.toString()
                            return <td key={i}>{value}</td>
                          })}
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <div style={{ marginBottom: '30px' }}>
          <div className='cardNew' style={{ marginBottom: '0px' }}>
            <div className='section-heading'>
              <h2>PG/Shareholder Consent</h2>
              <hr className='text-gray-400' />
            </div>
            <div>
              <label className='form-check form-check-inline form-check-solid me-5'>
                <input
                  name='confirmCheckbox'
                  type='checkbox'
                  id='form-check-input'
                  className={`form-check-input ${
                    (formik.submitCount > 0 || formik.errors.confirmCheckbox) &&
                    !formik.values.confirmCheckbox
                      ? 'is-invalid'
                      : ''
                  }`}
                  checked={formik.values.confirmCheckbox}
                  onChange={formik.handleChange}
                />
                <span className='ps-2 fs-4 text-justified'>
                  <b>By submitting this information, I hereby:</b> <br />
                  <ul className='text-justify gap-4 mt-4'>
                    <li className='mb-4'>
                      Confirm that all information provided is accurate, complete and correct.
                    </li>

                    <li className={'mb-4'}>
                      I hereby give my consent to CrediLinq A.I. Pte. Ltd. (CrediLinq), its
                      affiliates and partners, to consult with credit bureaus and relevant
                      government institutions to collect, share, and exchange my personal and
                      business data for purposes of the loan application process in accordance to
                      their privacy policy available [
                      <a
                        href={privacyPolicy()}
                        style={{ fontWeight: 500, textDecoration: 'underline', color: '#19147B' }}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        here
                      </a>
                      ].
                    </li>
                  </ul>
                </span>
              </label>

              <label className='form-check form-check-inline form-check-solid me-5 mt-4'>
                <input
                  name='promotionalMarketingCheckbox'
                  type='checkbox'
                  id='form-check-input'
                  className={`form-check-input`}
                  checked={formik.values.promotionalMarketingCheckbox}
                  onChange={formik.handleChange}
                />
                <span className='ps-2 fs-4 text-justified'>
                  I agree to receive marketing and promotional materials from CrediLinq via email,
                  SMS, phone calls, and other communication channels.
                </span>
              </label>
            </div>
          </div>
        </div>
        <div className='text-danger border-text'>
          {formik.errors.confirmCheckbox && <div>{formik.errors.confirmCheckbox}</div>}
        </div>

        <div className='cardNew stickeyFooter'>
          <div className='d-flex justify-content-between'>
            <button
              style={{ border: '1px solid #BDBDBD' }}
              onClick={backClick}
              className='button button-outline-primary'
            >
              <LeftArowIcon color='currentColor' fontSize={12} />
              Back
            </button>
            <button
              type='submit'
              id='button-primary'
              className='button button-primary '
              disabled={
                // Disable if:
                // 1. For company verification method 2: all 3 file types must be uploaded
                // 2. For company verification method 1: only credit bureau document is required
                // 3. Or if form is not valid or submitting
                !fileGroupValidation() ||
                !formik.isValid ||
                formik.isSubmitting ||
                !formik.values.confirmCheckbox
              }
            >
              Submit KYC <RightAeroIcon color='currentColor' />
            </button>
          </div>
        </div>
      </form>

      {showAlert && (
        <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
          {alertMsg}
        </Alert>
      )}
    </div>
  )
}

export { Step1Sub3 }
